import * as React from 'react';
import { useMemo } from 'react';
import MediaQuery from 'react-responsive';

import MobileFlight from '../MobileFlight';
import { OnFareSelect } from '../Results/types';
import { SelectedFare } from '../DesktopFlight/types';
import { isIncludePricesGroupM2Flight, TABLET_MIN_WIDTH } from '../utils';
import { ResultsLegFragment, AviaSearchParameters, FlightClass, AviaPassengerFareFragment } from '@websky/graphql';
import DesktopFlightRoute from '../DesktopFlightRoute/components/DesktopFlightRoute';
import { TransitTooltipContext } from '../TransitTooltip/utils';

export interface Props {
	legId?: number;
	flightIndex?: number;
	flight: ResultsLegFragment;
	flightIcon?: React.ReactNode;
	onSelect?: OnFareSelect;
	selectedFares?: SelectedFare[];
	passengerFares?: AviaPassengerFareFragment[];
	preselectedFlightClass?: FlightClass;
	singleFare?: boolean;
	singleFlight?: boolean;
	isPreOpenAvailable: boolean;
	isPreOpen: boolean;
	isRecommended?: boolean;
	isSelected?: boolean;
	hidePrice?: boolean;
	readonly?: boolean;
	canceled?: boolean;
	paid?: boolean;
	searchParameters?: AviaSearchParameters;
	hideOnlyPrice?: boolean;
	orderId?: string;
	onSubsidySuggestPopupOpen?: (next: () => void) => void;
	showSeatsLeftForAllFares?: boolean;
	hideConditionsButton?: boolean;
	isReturnFlight?: boolean;
	isSelectorInModal?: boolean;
	isFaresMilesMustBeRequested?: boolean;
	onSetViewFlight?: React.Dispatch<ResultsLegFragment>;
}

const Flight: React.FunctionComponent<Props> = ({
	legId,
	flightIndex,
	flight,
	singleFlight,
	onSelect,
	selectedFares = [],
	passengerFares = [],
	preselectedFlightClass,
	hidePrice,
	readonly,
	isRecommended,
	isSelected,
	canceled,
	paid,
	orderId,
	searchParameters,
	hideOnlyPrice,
	onSubsidySuggestPopupOpen,
	showSeatsLeftForAllFares,
	hideConditionsButton,
	isReturnFlight,
	isSelectorInModal = true,
	isFaresMilesMustBeRequested,
	onSetViewFlight
}) => {
	const isTransitTariff = useMemo(() => isIncludePricesGroupM2Flight(flight.pricesForFareGroups), [
		flight.pricesForFareGroups
	]);

	return (
		<TransitTooltipContext.Provider value={{ isTransitTariff }}>
			<MediaQuery minWidth={+TABLET_MIN_WIDTH + 1}>
				<DesktopFlightRoute
					legId={legId}
					flightIndex={flightIndex}
					orderId={orderId}
					selectedFares={selectedFares}
					passengerFares={passengerFares}
					flight={flight}
					isRecommended={isRecommended}
					singleFlight={singleFlight}
					onSelect={onSelect}
					isSelected={isSelected}
					canceled={canceled}
					hidePrice={hidePrice}
					readonly={readonly}
					searchParameters={searchParameters}
					hideOnlyPrice={hideOnlyPrice}
					onSubsidySuggestModalOpen={onSubsidySuggestPopupOpen}
					preselectedFlightClass={preselectedFlightClass}
					showSeatsLeftForAllFares={showSeatsLeftForAllFares}
					hideConditionsButton={hideConditionsButton}
					isReturnFlight={isReturnFlight}
					isSelectorInModal={isSelectorInModal}
					onSetViewFlight={onSetViewFlight}
					isFaresMilesMustBeRequested={isFaresMilesMustBeRequested}
				/>
			</MediaQuery>

			<MediaQuery maxWidth={TABLET_MIN_WIDTH}>
				<MobileFlight
					legId={legId}
					flightIndex={flightIndex}
					showAirplane={singleFlight}
					isRecommended={isRecommended}
					isSelected={isSelected}
					isPreOpen={false}
					flight={flight}
					onSelect={onSelect}
					selectedFares={selectedFares}
					passengerFares={passengerFares}
					hidePrice={hidePrice}
					readonly={readonly}
					searchParameters={searchParameters}
					hideOnlyPrice={hideOnlyPrice}
					canceled={canceled}
					orderId={orderId}
					onSubsidySuggestPopupOpen={onSubsidySuggestPopupOpen}
					preselectedFlightClass={preselectedFlightClass}
					onSetViewFlight={onSetViewFlight}
					isReturnFlight={isReturnFlight}
					isFaresMilesMustBeRequested={isFaresMilesMustBeRequested}
				/>
			</MediaQuery>
		</TransitTooltipContext.Provider>
	);
};

export default Flight;
